import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export default function RolesCatalog({ roles }) {
  return (
    <div>
      <h2 className="text-lg font-semibold text-slate-900 mb-3">Catalogo ruoli e permessi</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {roles.map((r) => (
          <Card key={r.role} className="border-slate-200" data-testid={`role-card-${r.role}`}>
            <CardHeader className="pb-2">
              <CardTitle className="text-sm">{r.label}</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="flex flex-wrap gap-1.5">
                {r.permissions.map((p) => (
                  <Badge key={p} variant="outline" className="bg-slate-50 text-slate-700 text-[11px]">{p}</Badge>
                ))}
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
